import { useState } from "react"


interface Props {
    handleCode: (data: string) => void
}

export default function CodeScrect(props: Props) {
    const [code, setcode] = useState<string>('')

    const onChange = (e: any) => {
        const value = e.target.value
        setcode(e.target.value)
        props.handleCode(value)
    }

    return (
        <div className="my-2">
            <label>Codigo secreto *:</label>
            <input
                className="form-control"
                type="password"
                placeholder="******"
                onChange={onChange}
                style={{ width: '300px' }}
            />
        </div>
    )
}
